<bic-popup (close)="onClose()" [customClass]="'w-[540px]'" [title]="'Seitenleiste anpassen'">
  <div bicPopupContent class="flex flex-col gap-4">
    <p class="text-xs text-gray-500">
      Angeheftete Prüfläufe erscheinen als Verknüpfung in der Seitenleiste. Die Reihenfolge lässt
      sich per Ziehen ändern.
    </p>

    <div class="flex items-center justify-between gap-4">
      <span class="text-xs font-medium text-gray-500 shrink-0">{{ pinnedCount }} von {{ total }} sichtbar</span>
      <div class="w-[268px]">
        <bic-input (valueChange)="search = $event"
                   [iconStart]="faMagnifyingGlass"
                   [placeholder]="'Prüflauf suchen...'"
                   [value]="search">
        </bic-input>
      </div>
    </div>

    @if (loading) {
      <p class="py-4 text-center text-sm text-gray-400">Favoriten werden geladen...</p>
    } @else {
      <div (cdkDropListDropped)="onDrop($event)"
           cdkDropList
           class="flex max-h-[400px] flex-col gap-2 overflow-y-auto">
        @for (check of filtered; track check.id) {
          <div [cdkDragDisabled]="!!search.trim()"
               cdkDrag
               class="flex items-center gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2.5">
            <div *cdkDragPlaceholder class="h-[46px] w-full rounded-lg border-2 border-dashed border-green"></div>
            <fa-icon [class.cursor-grab]="!search.trim()"
                     [class.cursor-not-allowed]="!!search.trim()"
                     [icon]="faGripDotsVertical"
                     cdkDragHandle
                     class="shrink-0 text-sm text-gray-300"></fa-icon>
            <span class="flex-1 truncate text-sm font-medium text-gray-900">{{ check.name }}</span>
            @if (getScope(check.id) === 'ORGANISATION') {
              <div class="flex shrink-0 items-center gap-1 rounded-md bg-gray-200 px-2.5 py-0.5">
                <fa-icon [icon]="faUsers" class="shrink-0 text-xs text-gray-700"></fa-icon>
                <span class="whitespace-nowrap text-xs font-medium text-gray-700">In Organisation geteilt</span>
              </div>
            } @else if (getScope(check.id) === 'PROJECT') {
              <div class="flex shrink-0 items-center gap-1 rounded-md bg-gray-200 px-2.5 py-0.5">
                <fa-icon [icon]="faBuilding" class="shrink-0 text-xs text-gray-700"></fa-icon>
                <span class="whitespace-nowrap text-xs font-medium text-gray-700">In Projekt geteilt</span>
              </div>
            }
            <input (change)="toggle(check.id)"
                   [checked]="isPending(check.id)"
                   class="h-4 w-4 shrink-0 cursor-pointer rounded border-gray-300 text-green accent-green focus:ring-green"
                   type="checkbox"/>
          </div>
        }
        @if (filtered.length === 0) {
          <p class="py-4 text-center text-sm text-gray-400">Keine Prüfläufe gefunden.</p>
        }
      </div>
    }
  </div>
  <div bicPopupButtonGroup class="flex w-full flex-row items-center">
    <button (click)="reset()"
            class="text-sm font-medium text-green hover:underline"
            type="button">
      Auf Standard zurücksetzen
    </button>
    <div class="flex-1"></div>
    <div class="flex gap-4">
      <bic-button (onClick)="onClose()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="onSave()" [disabled]="loading" [loading]="saving">Übernehmen</bic-button>
    </div>
  </div>
</bic-popup>
